import { defineStore } from "pinia";
import Network from "~/utils/network";
import { i18nInstance } from '~~/plugins/i18n';
import {ofetch} from "ofetch";

const urls = {
  getReviewQuestions: (publicId) =>
    `/administration/review/configs-public/${publicId}`,
  create: (publicId) => `/customer/review/create/${publicId}`,
  getSummary: `/api/customer/review/summary`,
  getBestSellingProducts: (financier) =>
    `/customer/review/best-selling/${financier}`,
  getFeaturedReviews: (countryId) => `/api/customer/review/featured/${countryId}`,
  getReviewById: (id) => `/customer/review/${id}`,
  saveVideoReview: (publicId) => `/drawer/video/customer/create/${publicId}`,
};

export const useReviewStore = defineStore("review", {
  state: () => ({
    reviewQuestions: {},
    reviewSummary: {},
    bestSellingProducts: [],
    featuredReviews: [],
    review: {},
  }),
  actions: {
    fetchReviewQuestions: async function (publicId) {
      try {
        const { list } = await Network.http(urls.getReviewQuestions(publicId), {
          method: "GET",
        });
        this.reviewQuestions = list.sort((a, b) => a.rowIndex - b.rowIndex);
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchReviewSummary: async function () {
      try {
        this.reviewSummary = await ofetch(urls.getSummary);
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchReviewById: async function (id) {
      try {
        this.review = await Network.http(urls.getReviewById(id), {
          method: "GET",
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    createReview: async function ({ publicId, review }) {
      try {
        await Network.http(urls.create(publicId), {
          method: "POST",
          body: review,
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchBestSellingProducts: async function (financier) {
      try {
        this.bestSellingProducts = await Network.http(
          urls.getBestSellingProducts(financier),
          { method: "GET" }
        );
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    fetchFeaturedReviews: async function (countryId) {
      try {
        this.featuredReviews = await ofetch(urls.getFeaturedReviews(countryId));
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
    saveVideoReview: async function ({ publicId, videoBlob }) {
      try {
        const formData = new FormData();
        formData.append("file", videoBlob);
        await Network.http(urls.saveVideoReview(publicId), {
          method: "POST",
          headers: { "Content-Type": "multipart/form-data" },
          body: formData,
        });
        useToast().add({
          message: i18nInstance.global.t("bnpl:review.videoReviewSaved.success"),
          duration: 3000,
          type: "success",
        });
      } catch (err) {
        console.log(err);
        await Promise.reject(err);
      }
    },
  },
  getters: {},
});
